var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 0a42.051 42.051 0 0 0-42 42 41.599 41.599 0 0 0 8.48 25.036L1.758 85.758a6 6 0 1 0 8.484 8.484L28.964 75.52A41.599 41.599 0 0 0 54 84a42 42 0 0 0 0-84Zm0 72a30 30 0 1 1 30-30 30.032 30.032 0 0 1-30 30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36h-6v-6a6 6 0 0 0-12 0v6h-6a6 6 0 0 0 0 12h6v6a6 6 0 0 0 12 0v-6h6a6 6 0 0 0 0-12Z"
  })));
};
export default SvgPlus;